﻿import path from 'node:path'
import fs from 'node:fs'
import { ResolvedConfig } from 'vite'

export function cdnPlugin() {
  let config: ResolvedConfig;
  return {
    name: 'remove-dev-assets',
    apply: 'build',

    // Hook to capture the resolved config
    configResolved(resolvedConfig: ResolvedConfig) {
      config = resolvedConfig;
    },

    closeBundle() {
      const outDir = config.build.outDir;
      const devAssetsDir = path.resolve(config.root, outDir, 'cdn');

      if (fs.existsSync(devAssetsDir)) {
        fs.rmSync(devAssetsDir, { recursive: true, force: true });
      }
    }
  };
}